export default __webpack_public_path__ + "static/media/Miley_9781408315927.0995a8ec.jpg";